export const MONITORING_EXCLUDE_CLASS = 'fs-exclude';

// Republic
export const REPUBLIC_TEAM_EMAIL = 'team@republic.co';

//Chromatic Ignore - for disabling snapshots for things like server time dates that will change on every snapshot
export const CHROMATIC_IGNORE = 'chromatic-ignore';
